export enum PermissionTypesEnum {
  // Admin - Uzivatele
  ADMIN_USER_READ = 'ADMIN_USER_READ',
  ADMIN_USER_CREATE = 'ADMIN_USER_CREATE',
  ADMIN_USER_UPDATE = 'ADMIN_USER_UPDATE',
  ADMIN_USER_DELETE = 'ADMIN_USER_DELETE',
  ADMIN_USER_RESET_PASSWORD = 'ADMIN_USER_RESET_PASSWORD',

  // Admin - Role
  ADMIN_ROLE_READ = 'ADMIN_ROLE_READ',
  ADMIN_ROLE_CREATE = 'ADMIN_ROLE_CREATE',
  ADMIN_ROLE_UPDATE = 'ADMIN_ROLE_UPDATE',
  ADMIN_ROLE_DELETE = 'ADMIN_ROLE_DELETE',

  // Admin - Security Groups
  ADMIN_SECURITY_GROUP_READ = 'ADMIN_SECURITY_GROUP_READ',
  ADMIN_SECURITY_GROUP_CREATE = 'ADMIN_SECURITY_GROUP_CREATE',
  ADMIN_SECURITY_GROUP_UPDATE = 'ADMIN_SECURITY_GROUP_UPDATE',
  ADMIN_SECURITY_GROUP_DELETE = 'ADMIN_SECURITY_GROUP_DELETE',

  // Admin - Organizace
  ADMIN_ORGANIZATION_READ = 'ADMIN_ORGANIZATION_READ',
  ADMIN_ORGANIZATION_FEATURE_EDIT = 'ADMIN_ORGANIZATION_FEATURE_EDIT',
  ADMIN_ORGANIZATION_UPDATE = 'ADMIN_ORGANIZATION_UPDATE',
  ADMIN_DELIVERY_WINDOW_READ = 'ADMIN_DELIVERY_WINDOW_READ',
  ADMIN_DELIVERY_WINDOW_UPDATE = 'ADMIN_DELIVERY_WINDOW_UPDATE',
  ADMIN_ORGANIZATION_EXPORT = 'ADMIN_ORGANIZATION_EXPORT',
  ADMIN_ORGANIZATION_IMPORT = 'ADMIN_ORGANIZATION_IMPORT',
  ADMIN_ORGANIZATION_MERGE = 'ADMIN_ORGANIZATION_MERGE',

  // Admin - Smluvni skupiny (contract_groups)
  ADMIN_CONTRACT_GROUP_READ = 'ADMIN_CONTRACT_GROUP_READ',
  ADMIN_CONTRACT_GROUP_CREATE = 'ADMIN_CONTRACT_GROUP_CREATE',
  ADMIN_CONTRACT_GROUP_UPDATE = 'ADMIN_CONTRACT_GROUP_UPDATE',
  ADMIN_CONTRACT_GROUP_DELETE = 'ADMIN_CONTRACT_GROUP_DELETE',
  ADMIN_CONTRACT_GROUP_SYNC_NP = 'ADMIN_CONTRACT_GROUP_SYNC_NP',

  // Admin - Reporty (report_definitions, report_scopes, report_scope_users)
  ADMIN_REPORT_READ = 'ADMIN_REPORT_READ',
  ADMIN_REPORT_CREATE = 'ADMIN_REPORT_CREATE',
  ADMIN_REPORT_UPDATE = 'ADMIN_REPORT_UPDATE',
  ADMIN_REPORT_DELETE = 'ADMIN_REPORT_DELETE',
  ADMIN_REPORT_ASSIGNMENT_EDIT = 'ADMIN_REPORT_ASSIGNMENT_EDIT',

  // Admin - Produkty
  ADMIN_PRODUCT_READ = 'ADMIN_PRODUCT_READ',
  ADMIN_PRODUCT_IMAGE_UPLOAD = 'ADMIN_PRODUCT_IMAGE_UPLOAD',
  ADMIN_PRODUCT_IMAGE_UPDATE = 'ADMIN_PRODUCT_IMAGE_UPDATE',
  ADMIN_PRODUCT_IMAGE_DELETE = 'ADMIN_PRODUCT_IMAGE_DELETE',

  // Admin - Kategorie
  ADMIN_CATEGORY_READ = 'ADMIN_CATEGORY_READ',

  // Admin - Aukce
  ADMIN_AUCTION_READ = 'ADMIN_AUCTION_READ',

  // Admin - Objednavky
  ADMIN_ORDER_READ = 'ADMIN_ORDER_READ',
  ADMIN_CART_READ = 'ADMIN_CART_READ',
  ADMIN_ORDER_UPDATE = 'ADMIN_ORDER_UPDATE',
  ADMIN_REQUISITION_READ = 'ADMIN_REQUISITION_READ',

  // Admin - Clanky
  ADMIN_ARTICLE_READ = 'ADMIN_ARTICLE_READ',
  ADMIN_ARTICLE_CREATE = 'ADMIN_ARTICLE_CREATE',
  ADMIN_ARTICLE_UPDATE = 'ADMIN_ARTICLE_UPDATE',
  ADMIN_ARTICLE_DELETE = 'ADMIN_ARTICLE_DELETE',

  // Admin - Emaily
  ADMIN_EMAIL_READ = 'ADMIN_EMAIL_READ',
  ADMIN_EMAIL_WRITE = 'ADMIN_EMAIL_WRITE',

  // Admin - Sync requesty
  ADMIN_SYNC_REQUEST_READ = 'ADMIN_SYNC_REQUEST_READ',
  ADMIN_SYNC_REQUEST_WRITE = 'ADMIN_SYNC_REQUEST_WRITE',

  // Admin - Audit synchronizace (audit + prohlizec davek), jen cteni
  ADMIN_SYNC_AUDIT_READ = 'ADMIN_SYNC_AUDIT_READ',

  // Admin - Kontrola dat (diff)
  ADMIN_SYNC_DIFF_READ = 'ADMIN_SYNC_DIFF_READ',

  // Admin - Stav prostredi
  ADMIN_ENV_CHECK_READ = 'ADMIN_ENV_CHECK_READ',

  // Admin - Odeslat sync data (jedna permission na celou obrazovku)
  ADMIN_SYNC_SEND = 'ADMIN_SYNC_SEND',

  // Admin - Inicialni load z externiho systemu, kazda akce zvlast
  ADMIN_INITIAL_LOAD_READ = 'ADMIN_INITIAL_LOAD_READ',
  ADMIN_INITIAL_LOAD_TRUNCATE = 'ADMIN_INITIAL_LOAD_TRUNCATE',
  ADMIN_INITIAL_LOAD_IMPORT_PORTALS = 'ADMIN_INITIAL_LOAD_IMPORT_PORTALS',
  ADMIN_INITIAL_LOAD_IMPORT_CATEGORIES = 'ADMIN_INITIAL_LOAD_IMPORT_CATEGORIES',
  ADMIN_INITIAL_LOAD_IMPORT_ORGANIZATIONS = 'ADMIN_INITIAL_LOAD_IMPORT_ORGANIZATIONS',
  ADMIN_INITIAL_LOAD_IMPORT_SUPPLIERS = 'ADMIN_INITIAL_LOAD_IMPORT_SUPPLIERS',
  ADMIN_INITIAL_LOAD_IMPORT_PRODUCTS = 'ADMIN_INITIAL_LOAD_IMPORT_PRODUCTS',
  ADMIN_INITIAL_LOAD_IMPORT_CATALOG_DATA = 'ADMIN_INITIAL_LOAD_IMPORT_CATALOG_DATA',
  ADMIN_INITIAL_LOAD_IMPORT_AUCTIONS = 'ADMIN_INITIAL_LOAD_IMPORT_AUCTIONS',

  // Admin - Docteni dat firmy ze stareho nakupniho portalu (vsechna tlacitka obrazovky)
  ADMIN_LOAD_NP_DATA = 'ADMIN_LOAD_NP_DATA',
  // Admin - Hromadna synchronizace firem s NP koordinatem
  ADMIN_NP_SYNC_USERS = 'ADMIN_NP_SYNC_USERS',
  ADMIN_NP_SYNC_ADDRESSES = 'ADMIN_NP_SYNC_ADDRESSES',
  ADMIN_CATALOG_IMPORT = 'ADMIN_CATALOG_IMPORT',

  // Admin - Import zavozu z NP
  ADMIN_DELIVERY_IMPORT = 'ADMIN_DELIVERY_IMPORT',
  ADMIN_PRICE_CORRECTION = 'ADMIN_PRICE_CORRECTION',

  // Admin - Vytezovani e-shopu dodavatelu (JIP, ...)
  ADMIN_ESHOP_EXTRACTION = 'ADMIN_ESHOP_EXTRACTION',

  // Admin - Elastic
  ADMIN_ELASTIC_READ = 'ADMIN_ELASTIC_READ',

  // Admin - Ulohy
  ADMIN_TASK_READ = 'ADMIN_TASK_READ',

  // Admin - Sessions
  ADMIN_SESSION_READ = 'ADMIN_SESSION_READ',
  ADMIN_SESSION_DELETE = 'ADMIN_SESSION_DELETE',

  // Admin - Impersonace (prihlaseni jako jiny uzivatel)
  ADMIN_IMPERSONATE = 'ADMIN_IMPERSONATE',
  ADMIN_IMPERSONATE_ANY = 'ADMIN_IMPERSONATE_ANY',

  // Admin - Pozvanky do dema
  ADMIN_DEMO_INVITE_READ = 'ADMIN_DEMO_INVITE_READ',
  ADMIN_DEMO_INVITE_SEND = 'ADMIN_DEMO_INVITE_SEND',

  // Client - Sprava uzivatelu
  CLIENT_USER_READ = 'CLIENT_USER_READ',
  CLIENT_USER_CREATE = 'CLIENT_USER_CREATE',
  CLIENT_USER_EDIT = 'CLIENT_USER_EDIT',
  CLIENT_USER_DELETE = 'CLIENT_USER_DELETE',
  CLIENT_USER_ROLE_EDIT = 'CLIENT_USER_ROLE_EDIT',
  CLIENT_USER_GROUP_EDIT = 'CLIENT_USER_GROUP_EDIT',

  // Client - Závozová okna
  CLIENT_DELIVERY_WINDOW_READ = 'CLIENT_DELIVERY_WINDOW_READ',
  CLIENT_DELIVERY_WINDOW_EDIT = 'CLIENT_DELIVERY_WINDOW_EDIT',
  CLIENT_DELIVERY_WINDOW_IMPORT = 'CLIENT_DELIVERY_WINDOW_IMPORT',
  CLIENT_DELIVERY_WINDOW_EXPORT = 'CLIENT_DELIVERY_WINDOW_EXPORT',

  // Vlastní dodavatelé
  // Prijemky (prijem na sklad) — rucni zadani za fakturacni skupinu
  CLIENT_STOCK_RECEIPT_EDIT = 'CLIENT_STOCK_RECEIPT_EDIT',

  CLIENT_MANUAL_SUPPLIER_ADD = 'CLIENT_MANUAL_SUPPLIER_ADD',
  CLIENT_MANUAL_SUPPLIER_DELETE = 'CLIENT_MANUAL_SUPPLIER_DELETE',

  // Vlastní produkty - přenos mezi společnostmi (XLSX)
  CLIENT_CUSTOM_PRODUCT_EXPORT = 'CLIENT_CUSTOM_PRODUCT_EXPORT',
  CLIENT_CUSTOM_PRODUCT_IMPORT = 'CLIENT_CUSTOM_PRODUCT_IMPORT',

  // AI asistent (kuchařský asistent v chat sidebaru)
  CLIENT_AI_ASSISTANT_USE = 'CLIENT_AI_ASSISTANT_USE',

  // Objednávky - kdo smí vytvořit jaký typ objednávky
  CLIENT_ORDER_CREATE = 'CLIENT_ORDER_CREATE',
  CLIENT_ORDER_CREATE_BLIND = 'CLIENT_ORDER_CREATE_BLIND',
  CLIENT_ORDER_CREATE_REQUISITION = 'CLIENT_ORDER_CREATE_REQUISITION',
  CLIENT_REQUISITION_PROCESS = 'CLIENT_REQUISITION_PROCESS',

  // Plánované objednávky (prémiová funkce SCHEDULED_ORDERS)
  CLIENT_SCHEDULED_ORDER_READ = 'CLIENT_SCHEDULED_ORDER_READ',
  CLIENT_SCHEDULED_ORDER_CREATE = 'CLIENT_SCHEDULED_ORDER_CREATE',
  CLIENT_SCHEDULED_ORDER_APPROVE = 'CLIENT_SCHEDULED_ORDER_APPROVE',
}
